<template>
  <b-card class="card-border-radius">
    <h6 class="font-weight-bold mb-4">Additional (-)</h6>

    <b-button
      v-if="!isView"
      class="btn-custom px-5 my-3"
      variant="info"
      size="sm"
      @click="addRowAdditional"
    >
      Add
    </b-button>
    <b-table
      thead-class="bg-color text-center"
      tbody-class="table-body"
      tfoot-class="table-body text-center"
      empty-text="No data"
      :items="form.bup_others_additional"
      :fields="additionalFields"
      show-empty
      responsive
      bordered
      foot-clone
    >
      <template v-slot:cell(description)="{ item }">
        <validation-provider
          name="Description Additional"
          rules="required"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-input
            v-model="item.description"
            autocapitalize="off"
            placeholder="Enter Description"
            size="sm"
            :class="{ 'is-invalid': errors.length }"
            :invalid-feedback="errors[0]"
            :disabled="isView"
          />
        </validation-provider>
      </template>
      <template v-slot:cell(unit)="{ item }">
        <validation-provider
          name="Unit Additional"
          rules="required"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-input
            v-model="item.unit"
            autocapitalize="off"
            placeholder="Enter Unit"
            size="sm"
            :class="{ 'is-invalid': errors.length }"
            :invalid-feedback="errors[0]"
            :disabled="isView"
          />
        </validation-provider>
      </template>
      <template v-slot:cell(qty)="{ item }">
        <validation-provider
          name="Qty Additional"
          rules="required|min_value:1"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-input
            v-model="item.qty"
            autocapitalize="off"
            placeholder="Enter Qty"
            type="number"
            size="sm"
            :class="{ 'is-invalid': errors.length }"
            :invalid-feedback="errors[0]"
            :disabled="isView"
          />
        </validation-provider>
      </template>
      <template v-slot:cell(price_unit_usd)="{ item }">
        {{ formatMoney(item.unit_price ? item.unit_price / fuelPrice.rate_usd_to_idr : 0, { symbol: '', precision: '2', thousand: ',' }) }}
      </template>
      <template v-slot:cell(unit_price)="{ item }">
        <validation-provider
          name="Price IDR Additional"
          rules="required|min_value:1"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-input
            v-model="item.unit_price"
            autocapitalize="off"
            placeholder="Enter Price/Unit"
            type="number"
            size="sm"
            :class="{ 'is-invalid': errors.length }"
            :invalid-feedback="errors[0]"
            :disabled="isView"
          />
        </validation-provider>
      </template>
      <template v-slot:cell(amount)="{ item }">
        {{ formatMoney(item.qty ? item.qty * item.unit_price : 0, { symbol: '', precision: '2', thousand: ',' }) }}
      </template>
      <template v-slot:cell(actions)="{ index }">
        <b-button
          v-if="!isView && form.bup_others_additional.length > 1"
          variant="link"
          class="text-decoration-none text-danger p-0"
          @click="removeAdditional(index)"
        >
          <fa-icon icon="times-circle" />
        </b-button>
      </template>
      <template #foot(description)>
        Total
      </template>
      <template #foot()>
        {{ '' }}
      </template>
      <template #foot(amount)>
        {{ formatMoney(subTotal(form.bup_others_additional), { symbol: '', precision: '2', thousand: ',' }) }}
      </template>

    </b-table>

    <b-card
      :style="'background: #DBF9F6'"
      class="border-0 card-border-radius my-3"
    >
      <b-form-checkbox
        variant="info"
        v-model="form.isInsentive"
        :value="true"
        :unchecked-value="false"
        @change="onCheck"
        :disabled="isView || !this.form.contractor_id || !this.form.periode"
      >
        Additional (+)
      </b-form-checkbox>
      <div v-if="form.isInsentive">
        <b-button
          v-if="!isView"
          class="btn-custom px-5 my-3"
          variant="info"
          size="sm"
          @click="addRowInsentive"
        >
          Add
        </b-button>
        <b-table
          thead-class="bg-color text-center"
          tbody-class="table-body"
          tfoot-class="table-body text-center"
          empty-text="No data"
          :items="form.bup_others_insentive"
          :fields="insentiveFields"
          show-empty
          responsive
          bordered
          foot-clone
        >
          <template v-slot:cell(description)="data">
            <validation-provider
              name="Description Additional (+)"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill mr-4"
              :vid="'desc'+data.index"
            >
              <vue-autosuggest
                v-model="data.item.description"
                autocapitalize="off"
                placeholder="Enter Description"
                size="sm"
                :invalid-feedback="errors[0]"
                :suggestions="filteredSuggestions"
                :input-props="{
                  id:'autosuggest__input',
                  placeholder: 'Enter Description',
                  disabled: isView,
                  class:{ 'red-border size-custom-input': errors.length }
                }"
                :getSuggestionValue="s => s.item.description"
                @input="(e) => onInputChange(e, data)"
                @selected="(e) => selectHandler(e, data)"
              >
              <template slot-scope="{ suggestion }">
                <div>
                  <b>{{suggestion.item.description}}</b>
                </div>
              </template>
              </vue-autosuggest>
            </validation-provider>
          </template>
          <template v-slot:cell(unit)="data">
            <validation-provider
              v-if="!data.item.contractor_additional_rate_id"
              name="Unit Additional (+)"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill mr-4"
              :vid="'unit'+data.index"
            >
              <b-form-input
                v-model="data.item.unit"
                autocapitalize="off"
                placeholder="Enter Unit"
                size="sm"
                :class="{ 'is-invalid': errors.length }"
                :invalid-feedback="errors[0]"
                :disabled="isView"
              />
            </validation-provider>
            <div v-else>
              {{ data.item.unit }}
            </div>
          </template>
          <template v-slot:cell(qty)="data">
            <validation-provider
              name="Qty Additional (+)"
              rules="required|min_value:1"
              v-slot="{ errors }"
              slim
              class="flex-fill mr-4"
              :vid="'qty'+data.index"
            >
              <b-form-input
                v-model="data.item.qty"
                autocapitalize="off"
                placeholder="Enter Qty"
                type="number"
                size="sm"
                :class="{ 'is-invalid': errors.length }"
                :invalid-feedback="errors[0]"
                :disabled="isView"
                @input="(el) => reCalculateAmount(el, data.index)"
              />
            </validation-provider>
          </template>
          <template v-slot:cell(unit_price)="data">
            <validation-provider
              v-if="!data.item.contractor_additional_rate_id"
              name="Price IDR Additional (+)"
              rules="required|min_value:1"
              v-slot="{ errors }"
              slim
              class="flex-fill mr-4"
              :vid="'unit_price'+data.index"
            >
              <b-form-input
                v-model="data.item.unit_price"
                autocapitalize="off"
                placeholder="Enter Price/Unit"
                type="number"
                size="sm"
                :class="{ 'is-invalid': errors.length }"
                :invalid-feedback="errors[0]"
                :disabled="isView"
                @input="(el) => reCalculateAmount(el, data.index)"
              />
            </validation-provider>
            <div v-else>
              {{ formatMoney(data.item.unit_price, { symbol: '', precision: '2', thousand: ',' }) }}
            </div>
          </template>
          <template v-slot:cell(fuel_cons)="data">
            <validation-provider
              v-if="!data.item.contractor_additional_rate_id"
              name="Fuel Cons Additional (+)"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill mr-4"
              :vid="'fuel_cons'+data.index"
            >
              <b-form-input
                v-model="data.item.fuel_cons"
                autocapitalize="off"
                placeholder="Enter Fuel Cons"
                size="sm"
                :class="{ 'is-invalid': errors.length }"
                :invalid-feedback="errors[0]"
                :disabled="isView"
                @input="(el) => reCalculateAmount(el, data.index)"
              />
            </validation-provider>
            <div v-else>
              {{ data.item.fuel_cons }}
            </div>
          </template>
          <template v-slot:cell(amount)="{ item }">
            {{ formatMoney(item.amount, { symbol: '', precision: '2', thousand: ',' }) }}
          </template>
          <template v-slot:cell(actions)="{ index }">
            <b-button
              v-if="!isView && form.bup_others_insentive.length > 1"
              variant="link"
              class="text-decoration-none text-danger p-0"
              @click="removeInsentive(index)"
            >
              <fa-icon icon="times-circle" />
            </b-button>
          </template>
          <template #foot(description)>
            Total
          </template>
          <template #foot()>
            {{ '' }}
          </template>
          <template #foot(amount)>
            {{ formatMoney(subTotalAmount(form.bup_others_insentive), { symbol: '', precision: '2', thousand: ',' }) }}
          </template>

        </b-table>
        <b-card class="border-0 card-border-radius mt-3" >
          <b-row>
            <b-col
              cols="1"
              class="d-flex align-items-center justify-content-center"
              v-if="!isView && form.bup_others_insentive.length > 1"
            >
              &nbsp;
            </b-col>
            <b-col>Total</b-col>
            <b-col>{{ formatMoney(subTotalAmount(form.bup_others_insentive), { symbol: '', precision: '2', thousand: ',' }) }}</b-col>
          </b-row>
        </b-card>
      </div>
    </b-card>
    <br>

    <h6 class="font-weight-bold">Attachment Supporting Document</h6>
    <div v-if="!isView" class="mt-4">
      <div>
        <div class="dropbox">
          <input
            type="file"
            @change="onChangeFile($event.target.files)"
            class="input-file"
            multiple
            accept=".xls, .xlsx, .doc, .docx, .pdf"
          >
            <img
              class="mt-2"
              src="@/assets/icon-upload.png"
              width="100"
              height="100"
            >
            <div>
              <p id="text-dropbox">Drag or klik button to upload file</p>
            </div>
            <b-button
              class="btn-custom"
              variant="info"
              size="sm"
            >
              Browse File
            </b-button>
        </div>
      </div>
    </div>
    <div
      v-if="attachmentAdditional.length"
      :style="gridStyle"
      class="card-list mt-2 p-0"
      id="attachment"
    >
      <div
        v-for="(item, index) in attachmentAdditional"
        :key="index"
        class="supporting-file"
      >
        <div
          class="dropbox-files mx-1 mb-2"
        >
          <div
            v-if="item.file_name"
            class="background-file"
          >
            <div class="d-flex justify-content-end">
              <img
                v-if="!isView"
                class="mr-2 mt-2"
                src="@/assets/icon-trash.png"
                width="25"
                height="25"
                style="cursor: pointer"
                @click="removeFile(index, item.id)"
              >
            </div>
            <div class="pointer" @click="downloadFile(item)">
              <img
                v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-excel.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[4]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-pdf.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-word.png"
                width="70"
                height="70"
              >
            </div>
          </div>
          <div
            class="text mt-2"
          >
            <span class="text-ellipsis mx-2">{{ item ? item.file_name : 'NaN'}}</span>
            <span class="size-file">{{ item ? item.size : 'NaN mb'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isView && !attachmentAdditional.length" class="w-100 text-center">No Attachment</div>
  </b-card>
</template>

<script>
import api from '@/api'
import { formatMoney } from 'accounting-js'

export default {
  props: {
    isView: {
      types: Boolean,
      default: false
    },
    isEdit: {
      types: Boolean,
      default: false
    },
    form: {
      types: Object,
      default: () => {}
    },
    fuelPrice: {
      types: Object,
      default: () => {}
    },
    contractor: {
      types: Object,
      default: () => {}
    }
  },

  components: {},

  data: () => ({
    additionalFields: [
      { key: 'description', label: 'Description', tdClass: 'text-center' },
      { key: 'unit', label: 'Unit', tdClass: 'text-center' },
      { key: 'qty', label: 'Qty', tdClass: 'text-center' },
      { key: 'price_unit_usd', label: 'Price/Unit (USD)', tdClass: 'text-center align-middle' },
      { key: 'unit_price', label: 'Price/Unit (IDR)', tdClass: 'text-center' },
      { key: 'amount', label: 'Amount (IDR)', tdClass: 'text-center align-middle' },
      { key: 'actions', tdClass: 'text-center', thStyle: 'width: 75px' }
    ],
    insentiveFields: [
      { key: 'description', label: 'Description', tdClass: 'text-center' },
      { key: 'unit', label: 'Unit', tdClass: 'text-center' },
      { key: 'qty', label: 'Qty', tdClass: 'text-center', thStyle: 'width: 300px' },
      { key: 'unit_price', label: 'Price/Unit (IDR)', tdClass: 'text-center' },
      { key: 'fuel_cons', label: 'Fuel Cons', tdClass: 'text-center align-middle' },
      { key: 'amount', label: 'Amount (IDR)', tdClass: 'text-center align-middle' },
      { key: 'actions', tdClass: 'text-center', thStyle: 'width: 75px' }
    ],
    numberOfColumns: 4,
    attachmentAdditional: [],
    attachmentType: ['xlsx', 'xls', 'doc', 'docx', 'pdf'],
    isUpload: false,
    upload: {
      progress: 0,
      variant: 'success'
    },
    suggestionsDescInsentive: []
  }),

  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(25%, 1fr))`
      }
    },
    filteredSuggestions() {
      return [
        {
          data: this.suggestionsDescInsentive.filter(data => {
            return (
              data.description.toLowerCase()
            )
          })
        }
      ]
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.fetchAttachment()
    }
  },

  methods: {
    formatMoney,
    async fetchAttachment() {
      this.attachmentAdditional = await api.other.getAttachment(this.$route.params.id, 'Additional')
    },
    addRowAdditional() {
      this.form.bup_others_additional.push({
        description: '',
        unit: '',
        qty: '',
        unit_price: '',
        amount: ''
      })
    },
    removeAdditional(index) {
      this.form.bup_others_additional = [
        ...this.form.bup_others_additional.slice(0, index),
        ...this.form.bup_others_additional.slice(index + 1)
      ]
    },
    onCheck(value) {
      if (value) {
        this.addRowInsentive()
      } else {
        this.form.bup_others_insentive = []
      }
    },
    addRowInsentive() {
      this.form.bup_others_insentive.push({
        contractor_additional_rate_id: null,
        description: '',
        unit: '',
        qty: '',
        unit_price: '',
        fuel_cons: '',
        amount: ''
      })
    },
    removeInsentive(index) {
      this.form.bup_others_insentive = [
        ...this.form.bup_others_insentive.slice(0, index),
        ...this.form.bup_others_insentive.slice(index + 1)
      ]
    },
    async onChangeFile(value) {
      let isTypeAllowed = true
      let isSizeAllowed = true
      if (value.length + this.attachmentAdditional.length > 10) {
        this.$nextTick(() => {
          this.$bvToast.toast('maximum file to upload only 10 files', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
        return
      }
      const formData = new FormData()
      for (let i = 0; i < value.length; i++) {
        const nameFile = value[i].name.split('.')
        if ((this.attachmentType.includes(nameFile[nameFile.length - 1]))) {
          if (value[i].size < 3072000) {
            formData.append('bup_others_file', value[i])
          } else {
            isSizeAllowed = false
            break
          }
        } else {
          isTypeAllowed = false
          break
        }
      }
      if (!isTypeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Only PDF, Excel and Doc files are allowed.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }

      if (!isSizeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Max size file 3 mb.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      if (isTypeAllowed && isSizeAllowed) {
        await this.uploadAttachment(formData, value)
      }
    },
    async uploadAttachment(formData, value) {
      try {
        const data = await api.other
          .uploadAttachment(
            this.$route.params.id ? this.$route.params.id : 0,
            'Additional',
            formData,
            { onUploadProgress: this.setUploadProgress }
          )
        if (!this.$route.params.id) {
          data[0].map(v => {
            this.form.attachmentAdditionalId.push(v)
          })
          for (const file of Object.entries(value)) {
            this.attachmentAdditional.push({
              file_name: file[1].name,
              size: this.formatBytes(file[1].size),
              url: file[1],
              id: null
            })
          }
          this.form.attachmentAdditionalId.map((v, i) => {
            this.attachmentAdditional[i].id = v
          })
        } else {
          setTimeout(() => this.fetchAttachment(), 1500)
        }
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    setUploadProgress({ loaded }) {
      this.upload.progress = loaded
    },
    checkType(fileName) {
      const splitFileName = fileName.split('.')
      return splitFileName[splitFileName.length - 1]
    },
    async removeFile(index, fileId) {
      try {
        this.attachmentAdditional.splice(index, 1)
        this.form.attachmentAdditionalId.splice(index, 1)
        await api.other.deleteAttachment(fileId)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    downloadFile(item) {
      window.open(item.url)
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    subTotal(item) {
      let x = 0
      item.map(v => {
        if (v.qty) {
          x += v.qty * (parseFloat(v.unit_price) || 0)
        }
      })
      return x
    },
    subTotalAmount(item) {
      let x = 0
      item.map(v => {
        if (v.amount) {
          x += parseFloat(v.amount) || 0
        }
      })
      return x
    },
    async onInputChange(e, params) {
      if (this.form.contractor_id) {
        this.form.bup_others_insentive[params.index].contractor_additional_rate_id = null
        const data = await api.contractor.additionalRate(this.form.contractor_id, { name: e })
        this.suggestionsDescInsentive = data
      }
    },
    selectHandler(data, e) {
      const selectedData = this.suggestionsDescInsentive.filter(el => el.description === data.item.description)[0]
      if (selectedData) {
        this.form.bup_others_insentive[e.index].contractor_additional_rate_id = selectedData.id
        this.form.bup_others_insentive[e.index].description = selectedData.description
        this.form.bup_others_insentive[e.index].unit = selectedData.unit
        this.form.bup_others_insentive[e.index].unit_price = !this.contractor.is_need_exchange_additional ? selectedData.rate : (selectedData.rate * this.fuelPrice.rate_usd_to_idr / this.contractor.rate_additional)
        this.form.bup_others_insentive[e.index].fuel_cons = selectedData.fuel_cons
        this.form.bup_others_insentive[e.index].amount = this.form.bup_others_insentive[e.index].unit_price + (this.fuelPrice.fuel_price_idr * selectedData.fuel_cons)
      }
    },
    reCalculateAmount(data, e) {
      this.form.bup_others_insentive[e].amount = (parseFloat(this.form.bup_others_insentive[e].unit_price || 0) + (this.fuelPrice.fuel_price_idr * parseFloat(this.form.bup_others_insentive[e].fuel_cons || 0))) * parseFloat(this.form.bup_others_insentive[e].qty || 0)
    }
  }
}
</script>
